export default function ({getters, rootGetters, commit, dispatch, state}, {field, value}) {
    let data = {}, item;
    switch (field) {
        case 'PaymentOperationID':
            commit('set', {PaymentOperationID: value});
            item = getters.paymentOperation.filter(i => {
                return i.value === value;
            })[0];
            dispatch('change', {field: 'CategoryId', value: item.category});
            dispatch('change', {field: 'PaymentTypeId', value: item.type});
            break;
        case 'CategoryId':
            if (state.CategoryId !== value && value !== 2) {
                commit('set', {CategoryId: value});
                dispatch('change', {field: 'PaymentTypeId', value: rootGetters['dictionaries/paymentType/select/filter']({category: value})[0].value});
                dispatch('change', {field: 'CashId', value: getters.cash[0].value});
                dispatch('change', {field: 'PaymentAccountId', value: getters.paymentAccount[0].value});
            }
            break;
        default:
            data[field] = value;
    }
    commit('set', data);
}
